export default "__VITE_ASSET__BUim2oSn__"